import { t } from '@ardoq/i18n';
import { ComponentDescriptionEditor } from '@ardoq/component-description-editor';
import { cellEditorPropsOperations } from './cellEditorPropsOperations';
import { CellEditor } from './types';
import { EDITOR_MIN_HEIGHT, RichTextCellEditor } from './RichTextCellEditor';

export const DescriptionEditor: CellEditor<string> = props => {
  const { i18nLocale, richTextEditorConfig, scopeData, config } = props.context;
  const title = t(
    i18nLocale,
    'inventory:descriptionEditor.title',
    'Edit description'
  );

  return (
    <RichTextCellEditor
      props={props}
      title={title}
      closeLabel={t(
        i18nLocale,
        'inventory:descriptionEditor.close',
        'Close description editor'
      )}
    >
      {({ value, onValueChange, setValue, setIsSaveBlocked }) => (
        <ComponentDescriptionEditor
          autoFocus
          ariaLabel={title}
          value={value}
          onValueChange={onValueChange}
          onGenerated={setValue}
          onGeneratingChange={setIsSaveBlocked}
          component={{
            name: props.data.name,
            // Resolved from the type id rather than read off `data.type`: the
            // grid's row data carries `typeId`, and the type name lives in
            // scope data (which is why the type column renders through the
            // same lookup).
            typeName:
              cellEditorPropsOperations.getComponentTypeNameById(
                props,
                props.data.typeId
              ) ?? '',
            workspaceName:
              scopeData.workspacesById[props.data.rootWorkspace]?.name ?? '',
          }}
          aiGeneration={config.aiDescriptionGeneration}
          toolbarExtensions={richTextEditorConfig}
          i18nLocale={i18nLocale}
          minHeight={EDITOR_MIN_HEIGHT}
          workspaceId={props.data.rootWorkspace}
        />
      )}
    </RichTextCellEditor>
  );
};
